import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "../common/components/Select";

const accessMap = t => ({0: t('readonly'), 1: t('full'), 2: t('notesonly')})

export const customCtrlDef = {
    toString: ({ value, defaultValue, t }) => {
        return value ? accessMap(t)[value] : defaultValue;
    },
    control: ({ value, def, ...props }) => <AccessDropdown value={value} access={def.access} {...props}></AccessDropdown>
}

const AccessDropdown = ({ value, access, placeholder, onChange, ...props }) => {
    const { t } = useTranslation();
    const accessOptions = useMemo(() => access.map(a => ({ key: accessMap(t)[a], value: a })), [access, t]);

    return <Select value={value} placeholder={placeholder ?? t('access')} labelField="key" valueField="value" options={accessOptions} onChange={onChange} {...props}></Select>
}
export default AccessDropdown;